var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 md12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm10: "", md10: "", layout: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", m2: "", md2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.codigo_producto.label,
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.formFields.codigo_producto.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.codigo_producto,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.codigo_producto.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm2: "", md2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.plataforma.label,
                                  items: _vm.plataformaList,
                                  "item-text": "producto",
                                  "item-value": "configid_producto",
                                  clearable: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.plataforma.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.plataforma,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.plataforma.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm2: "", md2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.producto.label,
                                  items: _vm.porductoList,
                                  "item-text": "configvalor_clase",
                                  "item-value": "configid_clase",
                                  clearable: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.producto.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.producto,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.producto.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm2: "", md2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.tipoequipo.label,
                                  items: _vm.tipoEquipoList,
                                  "item-text": "tipoeqname",
                                  "item-value": "tipoeqid",
                                  clearable: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.tipoequipo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoequipo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tipoequipo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm2: "", md2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.estado.label,
                                  items: [
                                    { id: "false", name: "ACTIVO" },
                                    { id: "true", name: "INACTIVO" }
                                  ],
                                  "item-text": "name",
                                  "item-value": "id",
                                  clearable: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.estado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.estado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm2: "", md2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.visible_cotizador.label,
                                  items: [
                                    { id: "true", name: "VISIBLE" },
                                    { id: "false", name: "NO VISIBLE" }
                                  ],
                                  "item-text": "name",
                                  "item-value": "id",
                                  clearable: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.visible_cotizador.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.visible_cotizador,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.visible_cotizador.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleBuscarClick } },
                              [
                                _c("v-icon", [_vm._v("search")]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { on: { click: _vm.clearFilters } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticStyle: { "margin-right": "5px" },
                            attrs: {
                              label: "Buscar...",
                              "append-icon": "search",
                              clearable: ""
                            },
                            on: { input: _vm.searchData },
                            model: {
                              value: _vm.filtrobusquedagrilla,
                              callback: function($$v) {
                                _vm.filtrobusquedagrilla = $$v
                              },
                              expression: "filtrobusquedagrilla"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        {
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: {
                            sm8: "",
                            md8: "",
                            layout: "",
                            wrap: "",
                            "justify-end": ""
                          }
                        },
                        [
                          _c("v-flex", { attrs: { sm1: "", md1: "" } }, [
                            _c(
                              "div",
                              { staticClass: "text-sm-center botones-filtros" },
                              [
                                _vm.accionExportar.visible
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticStyle: {
                                          "padding-right": "20px",
                                          display: "block",
                                          margin: "0 0 0 auto",
                                          "margin-top": "15px"
                                        },
                                        attrs: {
                                          flat: "",
                                          small: "",
                                          color: "primary"
                                        },
                                        on: { click: _vm.abrirModalImportar }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "importExportBtnIcon"
                                          },
                                          [_vm._v("cloud_upload")]
                                        ),
                                        _vm._v("  \n                  "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "importExportBtnTexto"
                                          },
                                          [
                                            _vm._v("Carga"),
                                            _c("br"),
                                            _vm._v("Masiva")
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _c(
                            "v-flex",
                            { attrs: { sm1: "", md1: "", "align-start": "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-sm-center botones-filtros"
                                },
                                [
                                  _vm.accionExportar.visible
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            "padding-right": "20px",
                                            display: "block",
                                            margin: "0 0 0 auto",
                                            "margin-top": "15px"
                                          },
                                          attrs: {
                                            flat: "",
                                            small: "",
                                            color: "primary"
                                          },
                                          on: { click: _vm.btn_exportar }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "importExportBtnIcon"
                                            },
                                            [_vm._v("cloud_download")]
                                          ),
                                          _vm._v("  \n                  "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "importExportBtnTexto"
                                            },
                                            [
                                              _vm._v("Exportar"),
                                              _c("br"),
                                              _vm._v("CSV")
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm1: "", md1: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    "padding-right": "20px",
                                    display: "block",
                                    margin: "0 0 0 auto",
                                    "margin-top": "15px"
                                  },
                                  attrs: { color: "#ffe800" },
                                  on: { click: _vm.crear_equipo }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { dark: "", left: "" }
                                    },
                                    [_vm._v("add_circle_outline")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "black" } },
                                    [_vm._v("Crear")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.dialog
        ? _c("VerCrearModal", {
            on: { cerrarCrear: _vm.handleCierreModalCrear }
          })
        : _vm._e(),
      _vm.dialog2
        ? _c("VerEditarModal", {
            attrs: { codigoEquipo: _vm.codigoEquipo },
            on: { cerrarCrear: _vm.handleCierreModalCrear }
          })
        : _vm._e(),
      _vm.ShowHistorico
        ? _c("HistorialTiposProducto", {
            attrs: {
              selectedCodigo: _vm.selectedCodigo,
              selectedNombre: _vm.selectedNombre
            },
            on: { cerrarHistorial: _vm.handleCierreModalCrear }
          })
        : _vm._e(),
      _vm.showImportar
        ? _c("ModalImportar", {
            on: {
              modalAsociacionEmit: _vm.handleCierreModalimportar,
              cerrarModal: _vm.handleCierreModalCrear
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }